module.exports = __webpack_public_path__ + "img/swipe-icon.9a59c13.svg";